import React__default from 'react';
import { Layout, Container } from './styles.js';
import { MarginContainer } from '../../styled.js';
import { RouteDropdown, ServiceListOption } from './atoms.js';

function SubHeader(_a) {
    var routes = _a.routes, containerSx = _a.containerSx;
    return (React__default.createElement(Layout, null,
        React__default.createElement(MarginContainer, null,
            React__default.createElement(Container, { sx: containerSx }, routes.map(function (r) {
                if ("element" in r) {
                    return React__default.createElement(React__default.Fragment, { key: r.id }, r.element);
                }
                else if ("routes" in r) {
                    var _a = r, id = _a.id, name_1 = _a.name, routes_1 = _a.routes, isCompactElements = _a.isCompactElements, secondaryTitle = _a.secondaryTitle;
                    return (React__default.createElement(RouteDropdown, { id: id, title: name_1, routes: routes_1, secondaryTitle: secondaryTitle, isCompactElements: isCompactElements }));
                }
                else {
                    return React__default.createElement(ServiceListOption, { key: r.id, route: r });
                }
            })))));
}

export { SubHeader as default };
